export const productDetailsAccordion = () => {
  const faq = document.querySelector(".details-accordions");
  if (!faq) return;

  const faqItems = faq.querySelectorAll(".details-accordion");

  const setExpanded = (item, expanded) => {
    item.classList.toggle("opened", expanded);

    const header = item.querySelector(".details-accordion__header");
    if (header) {
      header.setAttribute("aria-expanded", expanded ? "true" : "false");
    }
  };

  // Musi odpowiadac $transition-speed z variables/transitions.scss —
  // pozycje liczymy dopiero gdy zwijanie/rozwijanie sie skonczy.
  const TRANSITION_MS = 300;
  let scrollTimer = null;

  const scrollIntoViewIfNeeded = (item) => {
    const accordionPosition = item.getBoundingClientRect().top;
    const headerHeight = 100;
    const isInViewport =
      accordionPosition >= headerHeight &&
      accordionPosition <= window.innerHeight - headerHeight;

    if (isInViewport) return;

    window.scrollTo({
      top: window.pageYOffset + accordionPosition - headerHeight,
      behavior: "auto",
    });
  };

  const toggleFaq = (item) => {
    const isOpened = item.classList.contains("opened");

    faqItems.forEach((elem) => {
      if (elem !== item) setExpanded(elem, false);
    });

    setExpanded(item, !isOpened);

    if (isOpened) return;

    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(
      () => scrollIntoViewIfNeeded(item),
      TRANSITION_MS
    );
  };

  const setupExpandableItems = (accordion) => {
    const expandableItems = accordion.querySelectorAll(".expandable-item");
    const expandableContents = accordion.querySelectorAll(
      ".expandable-content"
    );

    if (expandableItems.length === 0 || expandableContents.length === 0) return;

    expandableItems.forEach((item) => {
      item.addEventListener("click", () => {
        const targetId = item.getAttribute("data-expandable");

        expandableItems.forEach((el) => el.classList.remove("active"));
        expandableContents.forEach((el) => el.classList.remove("active"));

        item.classList.add("active");
        const targetContent = accordion.querySelector(
          `[data-expandable-content="${targetId}"]`
        );

        if (targetContent) {
          targetContent.classList.add("active");
        }
      });
    });
  };

  faqItems.forEach((item) => {
    const header = item.querySelector(".details-accordion__header");
    if (header) {
      header.addEventListener("click", () => toggleFaq(item));
    }

    if (item.querySelector(".expandable-items")) {
      setupExpandableItems(item);
    }
  });

  const openPreferredAccordionItem = () => {
    const itemToOpen = faqItems[0];
    if (itemToOpen) setExpanded(itemToOpen, true);
  };

  openPreferredAccordionItem();
};
